"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _storeProvider = require("./../util/storeProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class OrderSummarySelectionComponent extends _react.PureComponent {
  render() {
    const {
      title,
      unitPrice,
      price,
      subTitle,
      term,
      termDisplay,
      unitPerTermDisplay,
      unitTypeDisplay,
      isInteger,
      qty,
      isOneTimeFee
    } = this.props;
    const {
      store
    } = this.context;
    let qtySummary = '';
    if (isInteger && qty && qty > 0) {
      const unitTypeText = unitTypeDisplay ? ` ${unitTypeDisplay}` : '';
      qtySummary = /*#__PURE__*/React.createElement("div", null, qty, unitTypeText, " x ", store.formatMicrounits(unitPrice), unitPerTermDisplay);
    }
    const durationText = isOneTimeFee ? termDisplay : `${term} ${termDisplay}`;
    return /*#__PURE__*/React.createElement("li", {
      className: "bd-b-1 mb-2 pb-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-black"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xs-5 col-lg-7"
    }, /*#__PURE__*/React.createElement("div", {
      className: "item-title bold"
    }, title)), /*#__PURE__*/React.createElement("div", {
      className: "col-xs-7 col-lg-5 text-right"
    }, /*#__PURE__*/React.createElement("div", {
      className: "item-price bold item-total-price text-black"
    }, store.formatMicrounits(price)))), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xs-5 col-lg-7"
    }, subTitle && /*#__PURE__*/React.createElement("div", {
      className: "item-subtitle text-muted"
    }, store.parseHtml(subTitle)), qtySummary), /*#__PURE__*/React.createElement("div", {
      className: "col-xs-7 col-lg-5 text-right"
    }, /*#__PURE__*/React.createElement("div", {
      className: "item-term text-muted bold"
    }, durationText)))));
  }
}
OrderSummarySelectionComponent.propTypes = {
  title: _propTypes.default.string,
  unitPrice: _propTypes.default.number,
  price: _propTypes.default.number,
  subTitle: _propTypes.default.string,
  term: _propTypes.default.number,
  termDisplay: _propTypes.default.string,
  unitPerTermDisplay: _propTypes.default.string,
  unitTypeDisplay: _propTypes.default.string,
  isInteger: _propTypes.default.bool,
  qty: _propTypes.default.number,
  isOneTimeFee: _propTypes.default.bool
};
var _default = exports.default = (0, _storeProvider.provideContext)(OrderSummarySelectionComponent);